import { useQuery } from "@tanstack/react-query";
import authorApiClient from "../../api/author";

const useUsers = (filters?: {
  manualPayout?: boolean;
  hasClock?: boolean;
  hasCollection?: boolean;
}) => {
  return useQuery({
    queryKey: ["users", filters],
    queryFn: async () => {
      return authorApiClient.getAllUsers(filters);
    },
  });
};

export default useUsers;
